import { createSelector } from '@reduxjs/toolkit'
import {
  getArrayFromCollection,
  getCollectionOrEmptyObject,
  getNestedProperty,
} from '@opallabs/lambda'
import {
  Assignment,
  Context,
  ContextCollection,
  Stage,
  Workflow,
} from '../../../../types'
import {
  getAssignment,
  getAssignments,
  getAssignmentsByStage,
} from '../../getters/entities/assignments'
import { getContexts } from '../../getters/entities/contexts'
import { getStages } from '../../getters/entities/stages'
import { getWorkflows } from '../../getters/entities/workflows'

export const selectAssignment = createSelector(
  [getAssignment],
  (assignment) => assignment
)

export const selectAssignments = createSelector(
  [getAssignments],
  (assignments) => getArrayFromCollection<Assignment>(assignments)
)

export const selectStages = createSelector([getStages], (stages) =>
  getCollectionOrEmptyObject<Stage>(stages)
)

export const selectWorkflows = createSelector([getWorkflows], (workflows) =>
  getCollectionOrEmptyObject<Workflow>(workflows)
)

export const selectContexts = createSelector([getContexts], (contexts) =>
  getCollectionOrEmptyObject<Context>(contexts)
)

export const selectAssignmentsByStage = () =>
  createSelector([getAssignmentsByStage], (assignments) => {
    if (!assignments || Object.keys(assignments).length === 0) return []

    return assignments
  })

export const selectAssignmentContextMap = createSelector(
  [selectAssignments, selectStages, selectWorkflows, selectContexts],
  (assignments, stages, workflows, contexts) => {
    const map: ContextCollection = {}
    assignments.forEach((assignment) => {
      const stageId = getNestedProperty<string>(
        assignment,
        'relationships',
        'stage',
        'id'
      )
      if (stageId !== undefined) {
        const stage = stages[stageId]
        if (stage !== undefined) {
          const workflowId = getNestedProperty<string>(
            stage,
            'relationships',
            'workflow',
            'id'
          )
          if (workflowId !== undefined) {
            const workflow = workflows[workflowId]
            if (workflow !== undefined) {
              const contextId = getNestedProperty<string>(
                workflow,
                'relationships',
                'context',
                'id'
              )
              if (contextId !== undefined) {
                const context = contexts[contextId]
                if (context !== undefined) {
                  map[assignment.id] = context
                }
              }
            }
          }
        }
      }
    })

    return map
  }
)
